import { StatusLabelType } from '@sdk/components/ui/StatusLabel';
import { IntegrationStatus, IntegrationType } from '@sdk/integrations/types';

const ERROR_STATUSES = [
  IntegrationStatus.errorConsent,
  IntegrationStatus.errorConfig,
  IntegrationStatus.errorBilling,
  IntegrationStatus.errorOauth,
];
const WARNING_STATUSES = [
  IntegrationStatus.error,
  IntegrationStatus.initializing,
  IntegrationStatus.maintenance,
  IntegrationStatus.queued,
  IntegrationStatus.locationMapping,
  IntegrationStatus.userMapping,
  IntegrationStatus.syncing,
];

export const getStatusLabel = (integration: IntegrationType): IntegrationStatus => {
  return integration.status === IntegrationStatus.error
    ? IntegrationStatus.maintenance
    : integration.status;
};

export const getStatusLabelType = (integration: IntegrationType): StatusLabelType => {
  const { status } = integration;

  if (status === IntegrationStatus.enabled) return StatusLabelType.success;
  if (ERROR_STATUSES.includes(status)) return StatusLabelType.danger;
  if (WARNING_STATUSES.includes(status)) return StatusLabelType.warning;

  return StatusLabelType.primary;
};
